import { memo } from "react";
import { format } from "date-fns";
import { Ban } from "lucide-react";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { BlacklistEntry } from "@/supabase/blacklist/types/blacklist";

// 고객 리스트 거파 배지 — 등록 고객에게만 렌더된다 (빈 명단 = 렌더 0, 스펙 §5.2).
// TooltipProvider는 Home 최상위가 이미 감싸고 있어 자체 Provider 불필요.
export const BlacklistBadge = memo(function BlacklistBadge({ entry }: { entry: BlacklistEntry }) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span
          tabIndex={0}
          role="img"
          className="inline-flex flex-shrink-0 ml-1 rounded-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-red-400"
          aria-label="거파 고객 배지"
        >
          <Ban className="w-3 h-3 text-red-500" />
        </span>
      </TooltipTrigger>
      <TooltipContent>
        <p className="font-semibold">거파 등록 고객입니다.</p>
        {entry.reason && (
          <p className="whitespace-pre-wrap break-words max-w-60">사유: {entry.reason}</p>
        )}
        <p>{format(new Date(entry.created_at), "yyyy. MM. dd")} 등록</p>
      </TooltipContent>
    </Tooltip>
  );
});
